// Copyright (c) 2021 Deere & Company

import {isNotNull} from '../../shared/services/claim-shared-helper';

export const canEnableSubmit = rates =>
    rates.some(rate => rate.currentRate !== rate.requestedRate) && rates.every(rate => isNotNull(rate.requestedRate) && !isNaN(rate.requestedRate));

export const isAnyRateLowerThanCurrentRate = rates =>
    rates.some(rate => rate.requestedRate < rate.currentRate);

export const isRequestSubmitted = laborRate =>
    laborRate.requestStatus.key === 'NEW';



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/services/labor-rate-change-services.js